var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonSolid = function SvgButtonSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 16V8q0-.824.587-1.412A1.93 1.93 0 0 1 4 6h16q.824 0 1.413.588Q22 7.175 22 8v8q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18zm3.25-5.25v1.5A.73.73 0 0 0 8 15a.73.73 0 0 0 .75-.75v-1.5h1.5A.73.73 0 0 0 11 12a.73.73 0 0 0-.75-.75h-1.5v-1.5A.73.73 0 0 0 8 9a.73.73 0 0 0-.75.75v1.5h-1.5A.73.73 0 0 0 5 12a.73.73 0 0 0 .75.75z"
  })));
};
export default SvgButtonSolid;